import React from 'react';
import { Link } from 'react-router-dom';

const MemberListItem = ({ id, firstName,middleName, lastName, relation, qualification,occupation,professionType,address,contact,dob }) => (
    <Link to={`/edit/${id}`} className="list-item">
      <div>
        <h3 className='list-item__title'>{firstName} {middleName} {lastName}</h3>
        <span className='list-item__subtitle'>      
        {occupation} 
        </span>
      </div>
        
        <h3 className='list-item__data'>{relation}</h3>

    </Link>
    
);

export default MemberListItem;



// WEBPACK FOOTER //
// ./src/components/MemberListItem.js